import { ShieldCheck, ArrowDown } from "lucide-react";
import { useLocale } from "@/lib/i18n/locale";

/**
 * "Free insurance benefits check" block.
 *
 * Wording: "we verify your coverage at no cost, whatever carrier you have" —
 * does NOT claim in-network status with any carrier.
 */
export const FreeBenefitsCheck = ({
  formSelector = "#saint-eligibility-form",
}: {
  formSelector?: string;
}) => {
  const { isEs } = useLocale();

  const heading = isEs
    ? "Verificación gratuita de beneficios del seguro"
    : "Free insurance benefits check";
  const description = isEs
    ? "Verificamos su cobertura sin costo, sea cual sea su aseguradora. La cobertura varía según el plan; confirmaremos sus beneficios antes de comenzar."
    : "We verify your coverage at no cost, whatever carrier you have. Coverage varies by plan; we'll confirm your benefits before you start.";
  const buttonText = isEs
    ? "Verificar mi elegibilidad"
    : "Check My Eligibility";

  return (
    <section className="py-10 sm:py-12 bg-muted/20 border-y border-border">
      <div className="container-px mx-auto max-w-4xl px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-5 rounded-2xl border border-accent/25 bg-card px-6 py-6 shadow-soft">
          <div className="flex items-center gap-4 text-center sm:text-left">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent/15 text-accent">
              <ShieldCheck className="h-6 w-6" />
            </span>
            <div>
              <h3 className="font-headings text-lg font-bold text-primary leading-snug">
                {heading}
              </h3>
              <p className="mt-1 text-sm text-muted-foreground leading-relaxed">
                {description}
              </p>
            </div>
          </div>
          <a
            href={formSelector}
            onClick={(e) => {
              e.preventDefault();
              const el = document.querySelector(formSelector);
              if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
                (el as HTMLElement).focus?.({ preventScroll: true });
              }
            }}
            className="inline-flex shrink-0 items-center gap-2 rounded-xl bg-gradient-accent px-6 py-3 text-sm font-bold text-accent-foreground shadow-glow hover:opacity-90 transition-opacity"
          >
            {buttonText}
            <ArrowDown className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default FreeBenefitsCheck;
